<div class="dialog__wrapper">
  <div class="dialog__header" mat-dialog-title>
    <h4 class="dialog__title">Generate New Token</h4>
    <button mat-dialog-close mat-icon-button>
      <mat-icon mat-button class="icon" fontIcon="close"></mat-icon>
    </button>
  </div>
  <mat-dialog-content class="dialog__content">
    <p><strong>If you have lost your unique token you will need to generate a new one by clicking the Generate button below.  Please note that any existing token will be immediately invalidated, and any API calls using that old token will fail.</strong></p>
    <p>You must now copy and paste this token for use in your API calls.  It will not be retrievable after you close this window.</p>

    <div *ngIf="token" class="dialog__token-container">
      <pre class="dialog__pre">{{ token }}</pre>
      <button mat-icon-button (click)="handleCopyButtonClick()">
        <mat-icon>content_copy</mat-icon>
      </button>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button (click)="handleGenerateTokenButtonClick()" *ngIf="!token">Generate</button>
  </mat-dialog-actions>
</div>
